import { useQuery } from "@tanstack/react-query";
import { listLieux, type LieuSearchParams } from "../api/lieuxApi";
import { queryKeys } from "../lib/queryKeys";

export function useLieuxList(params: LieuSearchParams) {
  return useQuery({
    queryKey: queryKeys.lieux.list(params),
    queryFn: () => listLieux(params),
  });
}
